import { createRouter, type RouterHistory } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { RouteError, type AuthStore } from '@pa/staff'
import { routeTree } from '@/routeTree.gen'
import type { StaffEnv } from './env'

/** Typed router context (Frontend §1.4, §5.3): the guards read `auth` and load `/v1/me` through `queryClient`. */
export interface RouterContext {
  queryClient: QueryClient
  env: StaffEnv
  auth: AuthStore
}

export function createAppRouter(context: RouterContext, history?: RouterHistory) {
  return createRouter({
    routeTree,
    context,
    defaultPreload: 'intent',
    // A page's own error renders inside the shell (Frontend §3.5); root and `_authed` set it too.
    defaultErrorComponent: RouteError,
    scrollRestoration: true,
    ...(history && { history }),
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>
  }
}
